import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TableNames } from "../../../../enums/tableNames";
import { RootState } from "../../../../redux/store/store";

/**
 * Filter selector hook with dynamic tabId support
 *
 * Extracts only the filters relevant to this specific table and tab from Redux.
 * The Redux store contains filters for ALL tables in the app, so this hook
 * ensures we only work with filters for the current auth status tab.
 *
 * Each tab (pending, hold, query, etc.) has separate filter state using the pattern:
 * `"generic_auth_status_table_${tabId}"`
 *
 * @param {string} tabId - Auth status tab identifier (e.g., "pending", "hold", "query")
 * @returns {FilterValues[]} Array of filters relevant to this table and tab
 *
 * @example
 * const validFilters = useValidFilters("pending");
 * // Returns filters with name === "generic_auth_status_table_pending"
 */
export const useValidFilters = (tabId: string) => {
  const { filters } = useSelector((state: RootState) => state.filterValues);

  const validFilters = useMemo(() => {
    return filters.filter(
      (filter) =>
        filter.name === `${TableNames.GENERIC_AUTH_STATUS_ORDERS}_${tabId}`,
    );
  }, [filters, tabId]);

  return validFilters;
};
